

import { useMutation, useQueryClient } from "@tanstack/react-query";
import { updateNotification } from "../../services/notification";
import { IIndicators } from "../../types";
import { toast } from "react-toastify";

const useUpdateNotification = (indicators: IIndicators) => {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: updateNotification,
        onMutate: () => {
            indicators.setIsProcessRunning(true);
        },
        onSuccess: (status) => {
            if (status === 200) {
                indicators.setIsProcessRunning(false);
                queryClient.invalidateQueries({ queryKey: ['notifications'] });
                toast.success("Notification updated successfully");
            }
        },
        onError: (error: any) => {
            indicators.setIsProcessRunning(false);
            indicators.setIsServiceError(error.response?.data?.message);
            toast.error(error.response?.data?.message);
        }
    });
}

export default useUpdateNotification;